import { defineReceiver } from '@drapejs/invoker';
import { fetchPage } from '@drapejs/core';
import { batch } from '@distancify/drapejs-litium';
import { gql } from 'graphql-request';

import {
  getProductsCarouselBlockCacheKey,
  hasProductDataSource,
} from '@/composables/useProductsCarouselBlock';
import { processBlocks } from '@/helpers/commandsHelper';

import { getProductsSearchFields } from './category';

export const schedule = defineReceiver(
  fetchPage,
  async function (_command, data) {
    await processBlocks(data, 'ProductsCarousel', async (block) => {
      if (!hasProductDataSource(block)) return;
      const tabs = block.fields.DataSource || [];
      for (let tab of tabs) {
        if (!tab || !tab.baseProductIds) continue;
        await this.invoke(batch.scheduleQuery, {
          cacheKey: getProductsCarouselBlockCacheKey(block, tab.tabCategorySystemId),
          query: gql`
          elasticSearch{
            productsCarouselBlockTabProducts(blockId: $blockId, tabName: $tabName){
              ${getProductsSearchFields()}
            }
          }`,
          variables: {
            blockId: {
              value: block.systemId,
              type: 'Guid!',
            },
            tabName: {
              value: tab.tabName,
              type: 'String!',
            },
          },
        });
      }
    });

    return data;
  }
);
